import * as React from "react";
import { styled, alpha } from "@mui/material";

import { makeStyles } from "@mui/styles";
import Color from "color";

export const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.background.main,
    color: theme.palette.text.main,
    padding: theme.spacing(2),
  },

  cardContentsWrapper: {
    display: "flex",
    flexDirection: "column",

    "& *": {
      margin: theme.spacing(0.5),
    },
  },

  cardHeader: {
    color: theme.palette.text.main,
    fontWeight: "900",
  },

  cardText1: {
    color: theme.palette.text.secondary,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },

  cardText2: {
    color: alpha(theme.palette.text.main, 0.7),
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },

  cardTextArea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },

  dataTableList: {
    width: "100%",
    overflowY: "scroll",
// overflowX:"",
// height:"100%"
    height:theme.spacing(42),

  },

  dataTableItem: {
    //  backgroundColor: "red",
    width: theme.spacing(60),
    transition: theme.transitions.duration.fancy,
    "&:hover": {
      backgroundColor: alpha(theme.palette.secondary.main, 0.1),
      color: theme.palette.secondary.main,
    },
  },

  //   dataTableItemPrimaryText: {
  //       fontWeight:700

  //   },

  dataTableItemSecondaryText: {
    "&:hover": {
      color: theme.palette.text.main,
    },
  },
}));
